import React from 'react';
import { Banner as BannerModel } from '../../../models';

interface HomeParagraphsBannerProps {
  bannerInfo: BannerModel;
}

export default function HomeParagraphsBanner({
  bannerInfo,
}: HomeParagraphsBannerProps) {
  return (
    <div className="text-color-primary-text-300 font-semibold gap-2 grid justify-items-center  md:px-0">
      {bannerInfo?.title === '' ? (
        <div className="text-color-primary-text-300 font-semibold gap-2 grid justify-items-center  md:px-0">
          <span
            className="flex lg:flex-row lg:justify-start
        md:justify-start justify-center w-full text-center"
          >
            <span className="flex text-2xl text-center my-auto">Brinda</span>
            <span className="flex lg:justify-start md:justify-start justify-center  font-bold text-4xl ml-2 lg:w-auto md:w-auto text-center bg-color-secondary-100 px-3">
              beneficios
            </span>
            <span className="lg:flex md:flex lg:justify-start justify-center md:justify-start text-4xl font-bold hidden lg:w-auto md:w-auto text-center bg-color-secondary-100 px-3">
              exclusivos
            </span>
          </span>
          <span className="lg:hidden md:hidden lg:justify-start justify-center  md:justify-start text-4xl font-bold flex lg:w-auto md:w-auto text-center bg-color-secondary-100 px-3">
            exclusivos
          </span>
          <span className="flex lg:justify-start justify-center  md:justify-start text-2xl   text-center">
            <span className="mr-2 text-center">y</span>
            <span className="flex lg:justify-start justify-center w-full md:justify-start text-4xl font-bold lg:w-auto md:w-auto text-center bg-color-secondary-100 px-3">
              personalizados
            </span>
            <span className="lg:flex md:flex lg:justify-start justify-center w-full md:justify-start text-3xl font-bold ml-2 hidden text-center">
              para tus beneficiarios
            </span>
          </span>
          <span className="flex lg:justify-start justify-center w-full md:justify-start text-2xl lg:hidden md:hidden text-center">
            para tus beneficiarios
          </span>
          <span className="flex lg:justify-start justify-center w-full md:justify-start text-2xl text-center lg:text-left md:text-left">
            en una sola plataforma mediante un modelo de suscripción.
          </span>
        </div>
      ) : (
        <span className="flex text-2xl my-auto lg:flex-row lg:justify-start md:justify-start justify-center w-full ">
          <h1>Este seria el titulo de la pantalla</h1>
        </span>
      )}
      {bannerInfo?.text.length === 0 ? (
        <span className="flex lg:justify-start justify-center w-full md:justify-start text-lg text-center lg:text-left md:text-left">
          Tus beneficiarios acceden a precios exclusivos en 8 categorías y
          pueden redimir cupones de consumo según el plan de membresía asignado.
        </span>
      ) : (
        <span className="flex lg:justify-start justify-center w-full md:justify-start text-lg text-center lg:text-left md:text-left">
          Este es el texto
        </span>
      )}
    </div>
  );
}
